(function(){
'use strict';

/**
 * @name replaceYoutubeWithNocookie
 * @kind filter
 */

function replaceYoutubeWithNocookie() {
  return function (input) {
    var youtubeRegex = /https:\/\/(www\.)?youtube\.com\/embed\/[^"\s]+/g;
    if (youtubeRegex.test(input)) {
      return input.replace(youtubeRegex, function (match) {
        return match.replace('youtube.com', 'youtube-nocookie.com');
      });
    }
    return input;
  };
}

angular.module('classy').filter('replaceYoutubeWithNocookie', replaceYoutubeWithNocookie);
})();